import { match, P } from "ts-pattern";
import { deepEqual } from "./deepEqual";
import { isObject } from "./isObject";

function isEmpty(value: unknown): boolean {
  return match(value)
    .with(P.nullish, () => true)
    .with(P.string, (v) => v.trim() === "")
    .with(P.array(P._), (arr) => arr.length === 0)
    .with(P.when(isObject), (obj) => Object.keys(obj).length === 0)
    .otherwise(() => false);
}

export function mergeKeepingCommon(values: unknown, nextValues: unknown) {
  const result = {};
  const allKeys = Array.from(new Set([...Object.keys(values), ...Object.keys(nextValues)]));

  for (const key of allKeys) {
    const val1 = values[key];
    const val2 = nextValues[key];

    if (deepEqual(val1, val2)) {
      result[key] = val1;
    } else if (isObject(val1) && isObject(val2)) {
      result[key] = mergeKeepingCommon(val1, val2);
    } else if (isEmpty(val1) && !isEmpty(val2)) {
      result[key] = val2;
    } else if (!isEmpty(val1)) {
      result[key] = val1;
    } else {
      result[key] = val2;
    }
  }

  return result;
}
